import axios from "axios";
import Config from "../config/Config";
import OrderInterface from "../interfaces/OrderInterface";
import authHeader from "./auth-header";

const API_URL = Config.BASE_URL_API;
const API_PUBLIC_URL = Config.BASE_URL_API_PUBLIC;

const functionsOrder = {
  getUserOrders(userID: string){
    return axios.get(API_URL + `/order/user/${userID}`, { headers: authHeader() });
  },
  getUserHistoricOrders(userID: string,  status: string){
    return axios.get(API_URL + `/order/user/historic/${userID}/${status}`, { headers: authHeader() })
  },
  getUserOrdersNumberPages(filters: any){
    return axios.post(API_URL + "/business/orders/numberPages", { filters }, { headers: authHeader() })
  },
  create(order: OrderInterface){
    return axios.post(API_URL + "/business/order/create", { order }, { headers: authHeader() })
  },
  tryToCreateNewOrder(newOrder: OrderInterface){
    return axios.post(API_URL + `/order/create`, newOrder, { headers: authHeader() });
  },
  getActiveOrders(userID: string){
    return axios.get(API_URL + `/order/user/${userID}/orders/active`, { headers: authHeader( )});
  },
  tryToCancelOrder(orderID: string){
    return axios.get(API_PUBLIC_URL + `/order/${orderID}/tryToCancel`, { headers: authHeader() });
  }
};

export default functionsOrder;